<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok"
           :loading="loading" @on-cancel="cancel"
           :width="600"
    >
      <h3 slot="header" class="modal-header">修改角色</h3>
      <Form :label-width="120">
        <FormItem label="角色名称" class="ivu-form-item-required">
          <Input class="item-width" v-model="roleName"></Input>
        </FormItem>
        <!--<FormItem label="角色编码" class="ivu-form-item-required">-->
        <!--<Input   class="item-width" ></Input>-->
        <!--</FormItem>-->
        <FormItem label="所属应用" class="ivu-form-item-required">
          <Select  class="item-width" placeholder="请选择" v-model="appType" :disabled="true">
            <Option v-for="item in appTypeList" :value="item.value" :key="'keyB'+item.value">{{item.text}}</Option>
          </Select>
        </FormItem>
        <FormItem label="功能菜单" class="ivu-form-item-required noselected">
          <div class="item-width"
               style="padding-left: 10px;height: 320px;overflow: auto;    border: 1px solid #dcdcdc;">
            <Tree :data="data" :multiple="true" show-checkbox ref="tree"></Tree>
          </div>
          <a href="javascript:void(0)" @click.stop="toCopy">权限复制</a>
        </FormItem>
      </Form>
      <character-list :n="pN" :appType="appType" @getRole="getRoles"></character-list>
    </Modal>
  </div>


</template>
<script>
  import CharacterList from './CharacterList'
  import {menuTree} from "../../../../api/menu";
  import {rolegetByIds, roleget} from "../../../../api/character";
  import {setTitleAndOthers, setCheckedFromData} from "../../js/systemmanage";
  import {roleedit} from "../../../../api/character";
  import {deepClone} from "../../../../utils/format";


  export default {
    name: "",
    components: {
      CharacterList
    },
    props: {
      n: {
        type: Number,
        default: 0
      },
      appType: {
        type: Number,
        default: 0
      },
      id: {
        type: [String, Number],
        default: ''
      }

    },
    watch: {
      n() {
        this.roleName = '';
        this.data = [];
        this.permIds=[];
        this.menuTree();
        this.isShow = true

      }
    },
    data() {
      return {
        pN: 0,
        data: [],
        loading: true,
        isShow: false,
        roleName: '',
        permIds: [],
        appTypeList:[{text:'自如寓后台',value:1},{text:'超级ZO',value:2},{text:'一三环境',value:3}],


      }
    },
    methods: {
      roleget() {
        if (!this.id) {
          return
        }
        roleget({id: this.id}).then(res => {
          //赋值 ，setCheck
          if (!res.data) {
            return
          }
          res.data.role && (this.roleName = res.data.role.roleName);
          res.data.permIds && setCheckedFromData(this.data, res.data.permIds)
        }).catch(error => {
        })
      },

      setPermIds() {

        if(!this.data.length){
          return []
        }

        let arrCheck = [];

        function dealArr(arr,parent) {
          arr.forEach(ele=>{
            let parenEle=deepClone(parent)
            if(ele.children && ele.children.length){
              parenEle.push(ele.parentValue);
              parenEle.push(ele.value)
              dealArr(ele.children,parenEle)
            }
            if (!ele.children || ele.children.length === 0) {
              if(ele.checked){
                parenEle.push(ele.value);
                arrCheck = arrCheck.concat(parenEle)
              }
            }
          })
        }
        dealArr(this.data,[])

        let res = [];
        let json = {};
        for (let i = 0; i < arrCheck.length; i++) {
          if (!json[arrCheck[i]]) {

            res.push(arrCheck[i]);

            json[arrCheck[i]] = 1;
          }
        }
        return res

      },

      getRoles(value) {
        rolegetByIds({ids: value}).then(res => {
          //设置筛选状态
          if (!res.data || res.data.length === 0) {
            return
          }
          setCheckedFromData(this.data, res.data)

        }).catch(error => {
        })
      },
      menuTree() {
        menuTree({appType:this.appType}).then(res => {
          if (!res.data) {
            return
          }
          setTitleAndOthers(res.data);
          this.data = res.data;
          this.roleget()
        }).catch(error => {
        })
      },
      toCopy() {
        this.pN++
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        // console.log(this.$refs['tree'].getCheckedNodes())


        if (!(this.roleName + '')) {
          this.$Message.info('请输入角色名称！');
          this.changeLoading();
          return
        }
        this.permIds = this.setPermIds();
        let params = {
          id:this.id,
          appType:this.appType,
          permIds: this.permIds,
          roleName: this.roleName
        };
        // console.log(this.permIds)
        roleedit(params).then(res => {
          this.$Message.success('修改成功');
          this.$emit('done')
        }).catch(error => {

        }).finally(() => {
          this.isShow = false

        })


      },
      cancel() {

      }
    }

  }
</script>

<style scoped>
  .item-width {
    width: 300px;
  }

</style>
